import { Button } from "@/components/ui/button";
import { Building2, Plus } from "lucide-react";
import { BankAccount } from "@/types/bank-statement";
import { Dropdown } from "@/components/ui/dropdown";
import { Dispatch, SetStateAction } from "react";

interface DemonstrativoExtratoBancarioHeaderButtonsProps {
  accounts: BankAccount[];
  selectedAccountId: string;
  onAccountChange: (accountId: string) => void;
  onImportClick?: () => void;
  onExportClick?: () => void;
  onLaunchOperationClick?: () => void;
}

export function DemonstrativoExtratoBancarioHeaderButtons({
  accounts,
  selectedAccountId,
  onAccountChange,
  onImportClick,
  onExportClick,
  onLaunchOperationClick,
}: DemonstrativoExtratoBancarioHeaderButtonsProps) {

  const formatLabel = (bank: Pick<BankAccount, 'bankName' | 'accountNumber' | 'bankLogoUrl'>) => (
    <div className="flex items-center gap-4">
      <span>
        <Building2 className="w-5 h-5 text-primary" />
      </span>

      <div className="leading-3">
        {bank.bankName}
        <br />
        <span className="text-xs">
          Conta: {bank.accountNumber}
        </span>
      </div>
    </div>
  )

  return (
    <div className="flex items-center justify-between w-full">
      <Dropdown
        options={accounts.map(a => ({
          id: a.id.toString(),
          label: formatLabel(a)
        }))}
        selected={selectedAccountId}
        onChange={onAccountChange as Dispatch<SetStateAction<string>>}
        focus="none"
        classNameContainer="w-56"
      />

      <div className="flex items-center gap-4">
        <Button
          size="sm"
          variant="secondary"
          onClick={onImportClick}
          className="w-40"
        >
          Importar
        </Button>

        <Button
          size="sm"
          variant="secondary"
          className="w-40 bg-purple-50 hover:bg-purple-50/90 text-purple-500"
          onClick={onExportClick}
        >
          Exportar
        </Button>

        <Button
          size="sm"
          variant="outline"
          className="w-40 text-purple-50"
          onClick={onLaunchOperationClick}
        >
          <Plus className="w-5 h-5 mr-1" />
          Novo Lançamento
        </Button>
      </div>
    </div>
  )
}